import React, { memo, ReactNode, useState } from 'react';
import Popup from "../../../HOC/Popup";
import AvailableDealers from "../../AvailableDealers";

interface Props {
  params: { [key: string]: string },
  children: ReactNode | ReactNode[] | null
}

const RenderModal = ( {
                        params,
                        children
                      }: Props ) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div onClick={setIsOpen.bind(null, true)}>
      {children}
      {isOpen && (
        <Popup onClose={setIsOpen.bind(null, false)} isOpen={true}>
          <div style={{maxWidth: 848, margin: '0 auto'}}>
            <AvailableDealers {...params as any} allowNoZip />
          </div>
        </Popup>
      )}
    </div>
  )
}

export default memo(RenderModal)
